import { organisationConstants } from '../../_constants/organisation.constants';
import { organisationService } from '../../_services/organisation.service';
import { organisationAction } from '../organisation.action';

export const orgEditRelationAction = {
    editRelation
};

function editRelation(selId,orgId, data) {
    return dispatch => {
        dispatch(request(data));
        organisationService.editRelation(selId,orgId, data)
            .then(
                relation => {
                    dispatch(organisationAction.getOrganisation(()=>{}))
                    dispatch(success(relation));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: organisationConstants.REQUEST_ORG_EDIT_RELATION, data } }
    function success(relation) { return { type: organisationConstants.RECEIVE_ORG_EDIT_RELATION, relation } }
    function failure(error) { return { type: organisationConstants.ORG_EDIT_RELATION_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/organisations/editRelation.action.js